import { get, patch } from '.';

export const getMe = () => get(`/api/utilisateurs/me`);
export const updatePassword = (userId, payload) =>
  patch(`/api/utilisateurs/${userId}/password`, payload);
